module.exports = __webpack_public_path__ + "img/site.21651d1d.svg";